import moment from 'moment';
import api from '../api';
import userStorage from './userStorage';
import adminpulse from '../utils/adminpulse';

const { ciEquals } = adminpulse;
const storageKey = 'EmployeeFilters';

const getStorage = () => {
  const { lastUpdate, filters = [] } = userStorage.getItem(storageKey) || {};
  return { lastUpdate, filters };
};
const setStorage = (filters = []) => {
  userStorage.setItem(storageKey, { lastUpdate: moment.utc().format(), filters });
};

let isLoaded = false;
const load = (force = false) => {
  const { lastUpdate, filters } = getStorage();
  if (!force && !!lastUpdate && moment.utc(lastUpdate).isAfter(moment.utc().subtract(1, 'hour'))) {
    // The last update was less than 1 hour ago, no need to call backend
    isLoaded = true;
    return Promise.resolve(filters);
  }
  return api.base.get(`/api/user/filter`).then(({ data }) => {
    const newFilters = data || [];
    setStorage(newFilters);
    isLoaded = true;
    return newFilters;
  });
};

const findFilterIndex = (filters, filter) => {
  // Find by id
  let idx = filters.findIndex(x => x.id === filter.id);
  if (idx >= 0) return idx;
  // Find by name
  idx = filters.findIndex(x => ciEquals(x.screen, filter.screen) && ciEquals(x.name, filter.name));
  return idx;
};
const getScreenFilters = screen => {
  if (!screen) return [];
  const { filters } = getStorage();
  return filters.filter(x => ciEquals(x.screen, screen));
};
const setFilter = filter => {
  if (!filter) return Promise.reject();

  return api.base.post(`/api/user/filter`, filter).then(({ data }) => {
    if (data) {
      const { filters } = getStorage();

      const newFilters = [...filters];
      const idx = findFilterIndex(newFilters, data);
      if (idx < 0) {
        newFilters.push(data);
      } else {
        newFilters[idx] = data;
      }
      setStorage(newFilters);
    }
    return data;
  });
};
const deleteFilter = filter => {
  if (!filter) return Promise.reject();

  return api.base.delete(`/api/user/filter/${filter.id}`).then(() => {
    const { filters } = getStorage();
    const newFilters = [...filters];
    const idx = findFilterIndex(newFilters, filter);
    if (idx >= 0) {
      newFilters.splice(idx, 1);
    }
    setStorage(newFilters);
  });
};

const EmployeeFilterService = {
  isLoaded: () => isLoaded,
  load,
  getScreenFilters,
  setFilter,
  deleteFilter,
};

export default EmployeeFilterService;
